import { v4 as uuid } from 'uuid';
export const shortId = () => uuid().split('-').join('');
